class Guest {

  constructor(index, name, mail, mobile) {
    this._index = index;
    this._name = name;
    this._mail = mail;
    
    if(!mail && !mobile) {
      throw new Error('Invalid guest');
    }

    this.setMobile(mobile);
  }

  getIndex() {
    return this._index;
  }

  getMobile() {
    return this._mobile;
  }

  getMail() {
    return this._mail;
  }

  getName() {
    return this._name;
  }

  setIndex(index) {
    this._index = index;
  }

  setMail(mail) {
    this._mail = mail;
  }

  setMobile(mobile) {

    if(mobile && mobile.length && mobile.length !== 11) {
      throw new Error('Invalid phone');
    }

    this._mobile = mobile;
  }

  setName(name) {
    this._name = name;
  }

}

export default Guest;



// WEBPACK FOOTER //
// ./src/classes/Guest.js